import React from 'react';
import './Sidebar.scss';
import logo from '../../Assets/Images/logo.svg';
import { Navigation } from '../Navigation/Navigation';
import { UserBrief } from '../UserBrief/UserBrief';

interface SidebarProps {
  firstName: string;
  lastName: string;
}

export const Sidebar: React.FC<SidebarProps> = ({ firstName, lastName }) => {
  return (
    <div className="sidebar">
      <UserBrief firstName={firstName} lastName={lastName} />
      <Navigation />
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
    </div>
  );
};
